<template>
  <el-dialog
    class="task-dialog"
    title="选择任务"
    :visible.sync="showDialog"
    :close-on-click-modal="false"
    :before-close="cancelAction"
    width="1000px"
  >
    <!-- 查询区 -->
    <ul class="search-btn">
      <li>
        <el-input
          v-model="params.task_title"
          placeholder="请输入任务名称"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <el-button
          type="primary"
          @click="searchList"
        >
          查询
        </el-button>
      </li>
    </ul>

    <div style="margin-bottom: 15px" />
    <el-table
      ref="singleTable"
      v-loading="loading"
      :data="storeData"
      tooltip-effect="dark"
      highlight-current-row
      :row-key="getRowKeys"
      @current-change="handleSelectionChange"
    >
      <el-table-column
        prop="task_title"
        width="200px"
        label="任务名称"
      />
      <el-table-column
        prop="time"
        label="任务时间"
      >
        <template slot-scope="scope">
          {{ scope.row.start_time_str }} - {{ scope.row.end_time_str }}
        </template>
      </el-table-column>
    </el-table>
    <div class="tr" />
    <div
      slot="footer"
      class="dialog-footer select-footer"
    >
      <div>
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :total="total_count"
          :current-page="params.page"
          :page-size="params.page_size"
          @current-change="handleCurrentChange"
        />
      </div>
      <div>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="saveStoreAction"
        >
          确定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getSalesperosnTask } from '@/api/task/shoppingGuideTask'

export default {
  props: {
    taskVisible: {
      // 展示选择门店的模态框
      type: Boolean,
      default: false
    },
    selectData: {
      // 已勾选的门店列表
      type: Object
    },
    submitLoading: {
      //提交的加载
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: false,
      storeData: [],
      multipleSelection: {},
      selectDatas: [],
      total_count: 0,
      params: {
        page: 1,
        page_size: 10,
        task_title: ''
      },
      selectCount: 0,
      firstShow: false
    }
  },
  computed: {
    showDialog () {
      return this.taskVisible
    }
  },
  watch: {
    taskVisible (newVal, oldVal) {
      if (newVal) {
        this.firstShow = true
        this.selectCount = this.selectData ? this.selectData.length : 0
        this.getNewsList()
      }
    }
  },
  methods: {
    // 换页可选择
    getRowKeys (row) {
      return row.task_id
    },

    // 分页器页面切换
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getNewsList()
    },

    // 查询门店
    searchList () {
      this.params.page = 1
      this.getNewsList()
    },

    // table表格选择
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 关闭模态框
    cancelAction () {
      this.$emit('closeTaskDialog')

      // 如果不需要默认勾选则关闭取消
      // if (!this.selectData) {
      //   this.multipleSelection = []
      //   this.selectCount = 0
      //   this.$refs.multipleTable.clearSelection()
      // }
    },
    // 保存绑定
    saveStoreAction () {
      // 保存storeIds
      let taskIds = []
      // let isExist = false
      // const multipleSelection = this.multipleSelection
      // if(this.selectDatas.length > 0){
      // this.selectDatas.map((item,index) =>{
      //   if(item.task_id === multipleSelection.task_id) {
      //     this.$message.error('该任务已选择')
      //     isExist = true
      //   }
      // })
      // }

      // if(!isExist){
      //  this.selectDatas.push(this.multipleSelection)
      // this.selectDatas.forEach((v) => {
      //   taskIds = taskIds.concat(v.task_id)
      // })
      // }
      this.$emit('chooseTask', this.multipleSelection)
    },
    // 获取门店列表
    async getNewsList () {
      this.loading = true
      this.params.time_type = this.type
      const data = await getSalesperosnTask(this.params)
      console.log('data---->', data)
      if (data) {
        this.loading = false
        this.storeData = data.list
        this.total_count = data.total_count

        // 获取选中元素 可传数组对象，也可传数组id
        if (this.firstShow) {
          this.firstShow = false
          // this.toggleSelection(this.selectData)
        }
      }
    }
    //   toggleSelection(rows) {
    //     if(rows)
    //     if (rows) {
    //         if (row.task_id) {
    //         // row = {contract_phone: "",region_id: "",store_bn: "",store_id: 615,store_name: ""}
    //         this.$refs.singleTable.toggleRowSelection(row, true)
    //       } else {
    //         // row = 615
    //         let newrow = { task_id: row }
    //         this.$refs.singleTable.toggleRowSelection(newrow, true)
    //       }
    //     } else {
    //       this.$refs.singleTable.clearSelection()
    //     }
    //   }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
.select-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
